export const Cupon =[
    {
      Header: "tipo2",
      accessor: "tipo2"
    },
    {
      Header: "Promocion",
      accessor: "Promocion"
    },
    {
      Header: "Convenio",
      accessor: "Convenio"
    }
  ];


  export const CuponesInicial={
    tipo2:"-",
    Promocion:"-"
  }
